import React, {Component} from "react";

class HomePage extends Component {
    render() {
        return <h1>Homepage</h1>
    }
}

export default HomePage;